import { Acceptatie as AcceptatieDlEntry } from "../../../../../.generated/forms/formstypes";
import { UiName, FieldMap } from "../../../../../shared/types";
import { target2field } from "../../../../../shared/utils/target-to-field";

export function mapDlTargetToAcceptatieUiField(target: string): UiName | null {
  const map: FieldMap<AcceptatieDlEntry> = {};

  return target2field(map, target);
}
